export default () => ({
    '& .ant-spin': {
        display: 'block',
        margin: '4rem auto',
    },
});
